/**
 * Plain turn-message text (no chip chrome) — shown centered in the header.
 * Optional piece glyph sits to the left of the copy when the game exports PlayerPiece.
 */
import type { ReactNode } from 'react'

export interface TurnIndicatorLabelProps {
  text: string
  textColor?: string
  /** Optional game-provided piece glyph. */
  piece?: ReactNode
  dataAttrs?: { 'data-player-number': string; 'data-player-symbol': string } | null
}

/** Whose-turn label. */
export function TurnIndicatorLabel({
  text,
  textColor,
  piece,
  dataAttrs,
}: TurnIndicatorLabelProps) {
  return (
    <div
      data-testid="turn-message"
      className="flex items-center gap-2 text-sm font-medium turn-message whitespace-nowrap"
      style={textColor ? { color: textColor } : undefined}
      aria-live="polite"
      {...(dataAttrs ?? undefined)}
    >
      {piece}
      <span>{text}</span>
    </div>
  )
}
